import { Injectable } from '@angular/core';
import { Action, State, StateContext, createSelector } from '@ngxs/store';
import { ShiftDrawerCollapseSectionEnum } from '@wilson/interfaces';
import { cloneDeep } from 'lodash';
import {
  SetShiftDrawerCollapseSectionSettings,
  SetShiftDrawerCollapseSettings,
} from './shift-drawer-settings.actions';

export interface ShiftDrawerSettingsModel {
  shiftDrawerSettings: {
    [userId in string]: Record<ShiftDrawerCollapseSectionEnum, boolean>;
  };
}

const defaults: ShiftDrawerSettingsModel = {
  shiftDrawerSettings: {},
};

@State<ShiftDrawerSettingsModel>({
  name: 'shiftDrawerSettings',
  defaults,
})
@Injectable()
export class ShiftDrawerSettingsState {
  static getShiftDrawerCollapseSettings(
    userId: string,
  ): (
    state: ShiftDrawerSettingsModel,
  ) => Record<ShiftDrawerCollapseSectionEnum, boolean> {
    return createSelector(
      [ShiftDrawerSettingsState],
      (state: ShiftDrawerSettingsModel) => {
        return state.shiftDrawerSettings[userId];
      },
    );
  }

  @Action(SetShiftDrawerCollapseSettings)
  setShiftDrawerCollapseSettings(
    ctx: StateContext<ShiftDrawerSettingsModel>,
    { userId, shiftDrawerCollapseSettings }: SetShiftDrawerCollapseSettings,
  ): void {
    const state = ctx.getState();
    const shiftDrawerSettingsToUpdate = cloneDeep(state.shiftDrawerSettings);
    shiftDrawerSettingsToUpdate[userId] = shiftDrawerCollapseSettings;
    ctx.patchState({
      shiftDrawerSettings: shiftDrawerSettingsToUpdate,
    });
  }

  @Action(SetShiftDrawerCollapseSectionSettings)
  setShiftDrawerCollapseSectionSettings(
    ctx: StateContext<ShiftDrawerSettingsModel>,
    { userId, section, isCollapsed }: SetShiftDrawerCollapseSectionSettings,
  ): void {
    const state = ctx.getState();
    const shiftDrawerSettingsToUpdate = cloneDeep(state.shiftDrawerSettings);
    shiftDrawerSettingsToUpdate[userId][section] = isCollapsed;
    ctx.patchState({
      shiftDrawerSettings: shiftDrawerSettingsToUpdate,
    });
  }
}
